import { Controller } from "@hotwired/stimulus";

export default class ButtonWithTooltipController extends Controller {

    static targets = [
        "button"
    ];

    static values = {
        enabledTitle: String,
        disabledTitle: String
    }

    readonly buttonTarget!: HTMLButtonElement;

    readonly hasEnabledTitleValue!: boolean;
    readonly enabledTitleValue!: string;
    readonly hasDisabledTitleValue!: boolean;
    readonly disabledTitleValue!: string;

    connect() {
        if (!this.hasEnabledTitleValue && !this.hasDisabledTitleValue) return;

        var observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.attributeName === "disabled") {
                    this.enabledDisabledChanged();
                }
            });
        });

        observer.observe(this.buttonTarget, {
            attributes: true
        });
    }

    enabledDisabledChanged() {
        const span = this.element as HTMLSpanElement;
        if (this.buttonTarget.disabled) {
            span.dataset.originalTitle = this.hasDisabledTitleValue
                ? this.disabledTitleValue
                : this.enabledTitleValue;
        } else {
            span.dataset.originalTitle = this.hasEnabledTitleValue
                ? this.enabledTitleValue
                : "";
        }
    }
}